import Request from './request'

const ClientRequestAction  = {
  activateDeviceClientRequestList(params, callback) {
    Request.post('client-request-action/activate-device', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  approveDeviceClientRequestList(params, callback) {
    Request.post('client-request-action/approve-service', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  deactivationDeviceClientRequest(params, callback) {
    Request.post('client-request-action/deactivate-device', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  // getClientRequestDevice(fid, callback) {
  //   Request.get('client-request-action/device-view/' + fid).then(callback).catch(this.bad_answer)
  // },
}

export default ClientRequestAction
